var React = require('react');

function RotateClockwise (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","stroke":"none","key":0}),React.createElement("path",{"d":"M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5","key":1})]);
}

RotateClockwise.defaultProps = {"className":"icon icon-tabler icon-tabler-rotate-clockwise","fill":"none","height":"24","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","viewBox":"0 0 24 24","width":"24"};

module.exports = RotateClockwise;

RotateClockwise.default = RotateClockwise;
